import { render } from "./CBoxFormulario.vue?vue&type=template&id=82c55748&scoped=true"
import script from "./CBoxFormulario.vue?vue&type=script&lang=js"
export * from "./CBoxFormulario.vue?vue&type=script&lang=js"

import "./CBoxFormulario.vue?vue&type=style&index=0&id=82c55748&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c55748"]])

export default __exports__